import React from 'react';
import { Panel, Stack } from 'rsuite';

import SplashScreen from './SplashScreen';
import Form from './Form';

const SignUp = () => {
  const [isLoading, setIsLoading] = React.useState(true);

  setTimeout(() => {
    setIsLoading(false);
  }, 3000);

  return (
    <>
      {isLoading ? (
        <Stack
          justifyContent="center"
          alignItems="center"
          direction="column"
          style={{
            height: '100vh'
          }}
        >
          <Panel
            // bordered
            // style={{ background: '#fff', width: 400 }}
            style={{ width: 400 }}
          >
            {/* <Brand /> */}
            {/* <img src={image} width={300} /> */}
            <SplashScreen />
          </Panel>
        </Stack>
      ) : (
        <Form />
      )}
    </>
  );
};

export default SignUp;
